import { createSlice } from '@reduxjs/toolkit';

export const ticketSlice = createSlice({
  name: 'ticket',
  initialState: {
    id: undefined as number | undefined,
  },
  reducers: {
    setTicketId: (state, action) => {
      state.id = action.payload;
    },
  },
});

export const { setTicketId } = ticketSlice.actions;

export const { reducer: ticketReducer } = ticketSlice;
